import { CategoryLabels } from '~/core/shared/types';

export const formatCategoryValue = (
  value: string,
  labels: CategoryLabels | undefined,
): string => labels?.[value] ?? value;
